import axios from '../../../src/utils/axios'

export default {
    upload (file) {
        return axios.post('/File', file)
            .then(response => {
                return response.data
            })
    },
}
